import { Component, Inject, ViewEncapsulation } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { ConfirmationDialogV2Data } from '@app/shared/models/dialog/confirmation-dialog-model';

@Component({
  selector: 'app-confirmation-dialog-v2',
  templateUrl: './confirmation-dialog-v2.component.html',
  styleUrls: ['./confirmation-dialog-v2.component.scss'],
  encapsulation: ViewEncapsulation.None,
})
export class ConfirmationDialogV2Component {
  errorIcon = `./assets/icons/circle-exclamation-error.svg`;

  constructor(
    @Inject(MAT_DIALOG_DATA) public dialogData: ConfirmationDialogV2Data,
    private readonly dialogRef: MatDialogRef<ConfirmationDialogV2Component>,
  ) {}

  closeModal(): void {
    this.dialogRef.close();
  }
}
